import {
  REDEEMCODES_REQUEST, REDEEMCODES_SUCCESS, REDEEMCODES_FAILURE,
  REDEEMCODE_REQUEST, REDEEMCODE_SUCCESS, REDEEMCODE_FAILURE,
  REDEEMCODE_ADD_REQUEST, REDEEMCODE_ADD_SUCCESS, REDEEMCODE_ADD_FAILURE,
  REDEEMCODE_UPDATE_REQUEST, REDEEMCODE_UPDATE_SUCCESS, REDEEMCODE_UPDATE_FAILURE,
  REDEEMCODE_DELETE_REQUEST, REDEEMCODE_DELETE_SUCCESS, REDEEMCODE_DELETE_FAILURE
} from '../actions/redeemcodes'

const INITIAL_STATE = {
  redeemCodes: null, redeemCodesNeedRefresh: false, redeemCode: null, error: null,
  loading: false
}

const redeemCodesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REDEEMCODES_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODES_SUCCESS:
      return {
        ...state,
        redeemCodes: action.response, redeemCodesNeedRefresh: false, error: null, loading: false
      }
    case REDEEMCODES_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_SUCCESS:
      return {
        ...state,
        redeemCode: action.response, error: null, loading: false
      }
    case REDEEMCODE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_ADD_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_ADD_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_ADD_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_UPDATE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_UPDATE_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    case REDEEMCODE_DELETE_REQUEST:
      return {
        ...state,
        error: null, loading: true
      }
    case REDEEMCODE_DELETE_SUCCESS:
      return {
        ...state,
        redeemCodesNeedRefresh: true, error: null, loading: false
      }
    case REDEEMCODE_DELETE_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    default:
      return state
  }
}

export default redeemCodesReducer